export const CREATE_EDIT_PHYSICAL_ITEMS = 'CREATE_EDIT_PHYSICAL_ITEMS';
export const PHYSICAL_LOADING = 'PHYSICAL_LOADING';
export const PHYSICAL_ITEMS_LOADING_ERROR = 'PHYSICAL_ITEMS_LOADING_ERROR';
export const RE_PHYSICAL_ITEM_LIST = 'RE_PHYSICAL_ITEM_LIST';
export const CLEAR_PHYSICAL_ERROR_SUCCESS = 'CLEAR_PHYSICAL_ERROR_SUCCESS';
export const SELECTED_PHYSICAL_DETAIL = 'SELECTED_PHYSICAL_DETAIL';
export const PHYSICAL_DETAIL_SUBMIT = 'PHYSICAL_DETAIL_SUBMIT';
export const SUBMIT_PHYSICAL_DETAIL_ERROR = 'SUBMIT_PHYSICAL_DETAIL_ERROR';
export const SUBMITTING_PHYSICAL_DETAIL = 'SUBMITTING_PHYSICAL_DETAIL';
export const FETCHING_PHYSICAL_DETAIL = 'FETCHING_PHYSICAL_DETAIL';
export const FETCHING_PHYSICAL_DETAIL_ERROR = 'FETCHING_PHYSICAL_DETAIL_ERROR';
export const CHECK_INCOMPLETE_PHYSICAL_RESULT =
  'CHECK_INCOMPLETE_PHYSICAL_RESULT';
export const CHECK_INCOMPLETE_PHYSICAL_ERROR =
  'CHECK_INCOMPLETE_PHYSICAL_ERROR';
export const SITE_WARNING_CHECK = 'SITE_WARNING_CHECK';
export const SITE_WARNING_DATA_LOADING = 'SITE_WARNING_DATA_LOADING';
export const SITE_WARNING_ERROR = 'SITE_WARNING_ERROR';
export const SAVE_PHYSICAL_DETAIL_ERROR = 'SAVE_PHYSICAL_DETAIL_ERROR';
export const FETCHING_PHYSICAL_ON_HAND = 'FETCHING_PHYSICAL_ON_HAND';
export const PHYSICAL_ON_HAND_DETAIL = 'PHYSICAL_ON_HAND_DETAIL';
export const FETCHING_PHYSICAL_ON_HAND_ERROR =
  'FETCHING_PHYSICAL_ON_HAND_ERROR';
export const SET_IS_LOAD_ONHAND_CLICKED = 'SET_IS_LOAD_ONHAND_CLICKED';
export const SITE_WARNING_DATA_LOADING_ERROR =
  'SITE_WARNING_DATA_LOADING_ERROR';
export const CLEAR_SITE_WARNING_DATA = 'CLEAR_SITE_WARNING_DATA';
export const CLEAR_SITE_WARNING_DATA_LOADING_ERROR =
  'CLEAR_SITE_WARNING_DATA_LOADING_ERROR';



// WEBPACK FOOTER //
// ./src/pages/inventory/transaction/physical/state/CreateEditPhysical/types.js